import { Link } from "react-router-dom";
import Footer from "../components/landing/Footer";
import LandingNavbar from "../components/landing/LandingNavbar";
import usePageSeo from "../hooks/usePageSeo";

/**
 * Public miss. No canonical: a not-found URL must not advertise the homepage
 * as its preferred URL. Nginx serves `public/404.html` with status 404 for
 * the same miss before this app boots; this view is the client-side case.
 */
export default function NotFound() {
    usePageSeo({
        title: "Page not found | FloGPT",
        description: "That page does not exist. Head back to the FloGPT homepage.",
        noindex: true,
    });

    return (
        <div className="bg-slate-900 min-h-screen">
            <LandingNavbar />
            <main className="pt-28">
                <div className="mx-auto max-w-3xl px-6 lg:px-8 pb-24">
                    <p className="text-sm font-medium text-orange-300">404</p>
                    <h1 className="mt-3 text-4xl font-bold tracking-tight text-white">Page not found</h1>
                    <p className="mt-4 text-slate-300 leading-relaxed">
                        That address is not a FloGPT page. The homepage, pricing, and docs are linked below.
                    </p>
                    <div className="mt-8 flex flex-wrap gap-3">
                        <Link
                            to="/"
                            className="inline-flex items-center rounded-xl bg-gradient-to-r from-orange-500 to-pink-500 px-5 py-2.5 text-sm font-semibold text-white"
                        >
                            Go to the homepage
                        </Link>
                        <Link
                            to="/pricing"
                            className="inline-flex items-center rounded-xl border border-white/15 px-5 py-2.5 text-sm font-semibold text-white"
                        >
                            Pricing
                        </Link>
                        <Link
                            to="/docs"
                            className="inline-flex items-center rounded-xl border border-white/15 px-5 py-2.5 text-sm font-semibold text-white"
                        >
                            Docs
                        </Link>
                    </div>
                </div>
            </main>
            <Footer />
        </div>
    );
}
